var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.tx ? _c('div', {
    staticClass: "card meta"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('p', {
    staticClass: "tx_type_label"
  }, [_vm._t("default")], 2), _c('h2', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('p', {
          staticClass: "click_to_copy"
        }, [_c('span', _vm._g({
          staticClass: "tx_hash",
          on: {
            "click": _vm.copy
          }
        }, on), [_vm._v(" " + _vm._s(_vm.tx.id) + " ")])])];
      }
    }], null, false, 1727944620)
  }, [_c('span', [_vm._v("Click to copy")])])], 1)]), _c('Metadata', {
    attrs: {
      "tx": _vm.tx,
      "is-staking": _vm.isStaking,
      "is-memo": _vm.isMemo
    }
  })], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }